var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3158 2.52632C14.3158 2.52632 14.3158 0.842113 16 0.842113C17.6842 0.842113 17.6842 2.52632 17.6842 2.52632V4.21053C17.6842 4.21053 17.6842 5.89474 16 5.89474C14.3158 5.89474 14.3158 4.21053 14.3158 4.21053V2.52632Z",
    fill: "#FFAC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4737 14.3158C29.4737 14.3158 31.1579 14.3158 31.1579 16C31.1579 17.6842 29.4737 17.6842 29.4737 17.6842H27.7895C27.7895 17.6842 26.1053 17.6842 26.1053 16C26.1053 14.3158 27.7895 14.3158 27.7895 14.3158H29.4737Z",
    fill: "#FFAC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21052 14.3158C4.21052 14.3158 5.89473 14.3158 5.89473 16C5.89473 17.6842 4.21052 17.6842 4.21052 17.6842H2.52631C2.52631 17.6842 0.842102 17.6842 0.842102 16C0.842102 14.3158 2.52631 14.3158 2.52631 14.3158H4.21052Z",
    fill: "#FFAC33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52302 6.98399C8.52302 6.98399 9.71375 8.17473 8.52302 9.36547C7.33228 10.5562 6.14154 9.36547 6.14154 9.36547L4.94996 8.17473C4.94996 8.17473 3.75923 6.98399 4.94996 5.79241C6.14154 4.60168 7.33228 5.79241 7.33228 5.79241L8.52302 6.98399Z",
    fill: "#FFAC33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2073 24.6678C26.2073 24.6678 27.398 25.8585 26.2073 27.0493C25.0165 28.24 23.8258 27.0493 23.8258 27.0493L22.6351 25.8585C22.6351 25.8585 21.4443 24.6678 22.6351 23.4771C23.8258 22.2863 25.0165 23.4771 25.0165 23.4771L26.2073 24.6678Z",
    fill: "#FFAC33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 9.36513C25.8594 9.36513 24.6686 10.5559 23.4779 9.36513C22.2871 8.17439 23.4779 6.98366 23.4779 6.98366L24.6686 5.79292C24.6686 5.79292 25.8594 4.60218 27.0501 5.79292C28.2408 6.98366 27.0501 8.17439 27.0501 8.17439L25.8594 9.36513Z",
    fill: "#FFAC33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17516 27.0493C8.17516 27.0493 6.98442 28.2401 5.79368 27.0493C4.60294 25.8586 5.79368 24.6679 5.79368 24.6679L6.98442 23.4771C6.98442 23.4771 8.17516 22.2864 9.36589 23.4771C10.5566 24.6679 9.36589 25.8586 9.36589 25.8586L8.17516 27.0493Z",
    fill: "#FFAC33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3158 27.7895C14.3158 27.7895 14.3158 26.1053 16 26.1053C17.6842 26.1053 17.6842 27.7895 17.6842 27.7895V29.4737C17.6842 29.4737 17.6842 31.1579 16 31.1579C14.3158 31.1579 14.3158 29.4737 14.3158 29.4737V27.7895Z",
    fill: "#FFAC33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4211 16C24.4211 11.3491 20.6501 7.57895 16 7.57895C11.3491 7.57895 7.57895 11.3491 7.57895 16C7.57895 20.6501 11.3491 24.4211 16 24.4211C20.6501 24.4211 24.4211 20.6501 24.4211 16Z",
    fill: "#FFAC33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.d38d8911cb512764d8b32796aa5069d1.svg";
export { ForwardRef as ReactComponent };